import React from "react"
import { Card, CardBody } from "reactstrap"


const NoDataMessage = ({ content = "No data to display" }) => {
  return (
    <Card>
      <CardBody className={'p-2 text-center'}>
        {content}
      </CardBody>
    </Card>
  )
}

export default NoDataMessage